import React from 'react'
import TextControl from './../../../../../modules/TextControl'
import DateControl from './../../../../../modules/DateControl'
import CheckboxControl from './../../../../CheckboxControl'
import UnknownControl from './../../../../UnknownControl'
import ListControl from './../../../../ListControl'
import componentMap from './../componentMap'
import RadioControl from './../../../../RadioControl'

var draggingComponentMap = {
  'text': props => <TextControl {...props} dragging={true} />,
  'date': props => <DateControl {...props} dragging={true} />,
  'checkbox': props => <CheckboxControl {...props} dragging={true} />,
  'list': props => <ListControl {...props} dragging={true} />,
  'radio': props => <RadioControl {...props} dragging={true} />,
}

// Ensure the dragging version has all the same types as the real version
Object.keys(componentMap).forEach(key => {
  if (!draggingComponentMap[key])
    throw new Error(`The dragging component map is missing type '${key}'.`)
})

export default draggingComponentMap


/**
 * Returns the component map but with any missing component types given
 * a default 'Unknown' component.
 * @param {Array<string>} types All the component types
 * @returns {object}
 */
export function shimMissingComponentTypes(types){
  const defaultTypes = [
    'header-one',
    'header-two',
    'header-three',
    'header-four',
    'header-five',
    'header-six',
    'unstyled',
  ]
  var newComponentMap = Object.assign({}, componentMap),
    changed = false
  types.forEach(type => {
    if (defaultTypes.includes(type) || newComponentMap[type])
      return
    newComponentMap[type] = props => <UnknownControl {...props} dragging={true} />
    changed = true
  })
  return changed ? newComponentMap : componentMap
}


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/ScreenRenderer/DraggingFieldsScreenRenderer/componentMap.js